// SwiperSlider.js
import StencilHTMLElement from "./stencil-element";

class SwiperSlider extends StencilHTMLElement {
  name = "SwiperSlider";
  instance;
  #options;

  constructor() {
    super();
  }

  get options() {
    return this.#options;
  }

  set options(value) {
    this.#options = value;
    this.init();
  }

  connectedCallback() {
    console.log(this.logPrefix, "Connected to DOM");
    // Parse JSON options attribute if present (non-function bits only)
    if (!this.#options && this.hasAttribute("options")) {
      try {
        this.#options = JSON.parse(this.getAttribute("options") || "{}");
      } catch {
        // ignore parse errors
      }
    }

    // Always request function callbacks from the host app
    this.dispatchEvent(
      new CustomEvent("swiper-slider:configure", {
        bubbles: true,
        detail: {
          el: this,
          setOptions: (opts) => {
            this.options = opts;
          }
        }
      })
    );

    this.init();
  }

  disconnectedCallback() {
    console.log(this.logPrefix, "Disconnected from DOM");
    if (this.instance) {
      this.instance.destroy(true, true);
      this.instance = undefined;
    }
  }

  init() {
    if (this.instance) {
      this.instance.destroy(true, true);
      this.instance = undefined;
    }

    const base = this.#computeBaseFromAttributes();
    const opts = {
      ...base,
      ...(this.#options || {})
    };

    // @ts-ignore
    this.instance = new window.Swiper(this.firstElementChild, opts);
  }

  #computeBaseFromAttributes() {
    const slideClass  = this.getAttribute("slide-class");
    const gutterClass = this.getAttribute("gutter-class");
    const navEnabled  = this.getAttribute("navigation") === "true";

    const opts = {
      resizeObserver: false
    };

    if (navEnabled) {
      opts.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      };
    }

    if (slideClass || gutterClass) {
      opts.breakpoints = MP.Utilities.getSwiperBreakpointsByColAndGutter(slideClass, gutterClass);
    } else {
      // Sensible base default
      opts.slidesPerView = 1;
      opts.spaceBetween  = 0;
    }

    return opts;
  }
}

export default SwiperSlider;